import React from 'react';
import { EVENT_ICONS, EVENT_NAMES } from './EventStyles';

class CalendarItem extends React.Component {
  getName() {
    const event = this.props.event;
    if (event.event_type === 'show') {
      return `${event.place.city}, ${event.place.state}`;
    }
    return event.name ? event.name : EVENT_NAMES[event.event_type];
  }
  renderGroupItem() {
    const event = this.props.event;
    const style = {
      color: '#FFFFFF',
    };
    let name = `${event.group_name} @ ${event.place.city} ${event.place.state}`;
    let icon = EVENT_ICONS[this.props.event.event_type];
    if (event.bids.hotel) {
      name = `${event.group_name} - ${event.bids.hotel.name}`;
    } else if (event.event_type === 'nost') {
      name = `${event.group_name} - No hotel needed.`;
    } else {
      style.color = '#FFFFFF';
      icon = 'fa-frown-o';
      name = `${event.group_name} @ ${event.place.city} ${event.place.state}`;
    }
    if (icon) {
      const label = `fa ${icon} fa-lg`;
      return (
        <span>
          <i className={label} style={style} /> {name}
        </span>
      );
    }
    return <span>{name}</span>;
  }
  renderItem() {
    const name = this.getName();
    const style = {};
    if (EVENT_ICONS[this.props.event.event_type]) {
      const label = `fa ${EVENT_ICONS[this.props.event.event_type]}`;
      return (
        <span>
          <i className={label} aria-hidden="true" style={style} />
          {name}
        </span>
      );
    }
    return <span>{name}</span>;
  }
  render() {
    if (this.props.group) {
      return this.renderGroupItem();
    }
    return this.renderItem();
  }
}

export default CalendarItem;



// WEBPACK FOOTER //
// src/routes/tours/components/CalendarItem.js